import script from "./CottonCakekhataBook.vue?vue&type=script&setup=true&lang=js"
export * from "./CottonCakekhataBook.vue?vue&type=script&setup=true&lang=js"

import "./CottonCakekhataBook.vue?vue&type=style&index=0&id=47cc68bf&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47cc68bf"]])

export default __exports__